import React, { Component } from 'react';
import styles from './inputs/inputs.css';
import infoIcon from '../../assets/icons/icon_info.svg';

// Data. Returns normal JSON file for now.
import currencies_json from '../../data/currencies.json';
import devices_json from '../../data/devices.json';
import scenarios_json from '../../data/scenarios.json';
import din_json from '../../data/din_printarea.json';
import pretreatment_json from '../../data/pretreatment.json';
import ink_json from '../../data/ink.json';

// Grab inputs
import CurrencyDropdown from './inputs/c_currency_dropdown';
import ReadOnlyInput from './inputs/c_readonly_input';
import OverviewGroup from './inputs/c_overview_group';
import SliderGroup from './inputs/c_slider_group';
import DropdownGroup from './inputs/c_dropdown_group';
import UserInput from './inputs/c_user_input';
import ScenarioDropdown from './inputs/c_scenario_dropdown';

// Grab graphs
import BarChart from './charts/c_bar_chart';
import PieChart from './charts/c_pie_chart';

// Grab totals
import Totals from './totals/c_totals';
import ScenarioOverview from './totals/c_scenario_overview';

import Room from './../room/room';
import Overlay from './../overlay/overlay';

// Help
import Help from './help/help';
import Steps from './step-by-step/step-by-step';

import Lang from '../../i18n'
import { withRouter } from 'react-router-dom'

var classNames = require('classnames');

class Calculator extends Component {

  constructor(props) {
    super(props);
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    this.handleDinChange = this.handleDinChange.bind(this);
    this.handlePretreatmentChange = this.handlePretreatmentChange.bind(this);
    this.handleInkQtyChange = this.handleInkQtyChange.bind(this);
    this.handlePrintColorPercentageChange = this.handlePrintColorPercentageChange.bind(this);
    this.handleTextileColorPercentageChange = this.handleTextileColorPercentageChange.bind(this);
    this.handleUserInputChange = this.handleUserInputChange.bind(this);
    this.handleScenarioChange = this.handleScenarioChange.bind(this);
    this.handleDeviceUserInputChange = this.handleDeviceUserInputChange.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state = {
      currency: currencies_json[0],
      scenario: scenarios_json[0],
      recommendedDevices: [],
      allDevices: devices_json,
      additionalDevices: [],//This will be populated via the room builder
      devicePricing: [],// This will grab the totals for devices
      deviceInvestment: 0,
      din: [],
      pretreatment: [],
      pretreatmentPricing: [],
      pretreatmentPrice: 0,
      hasPretreatmaker: true,// When 100% white colour, set this to false as we don't need it.
      ink: [],
      inkPricing:[],
      printColorPercentage: 20,
      textileColorPercentage: 30,
      demandVolume: 400,
      productionWeeks: 48,
      productionHours: 8,
      personnelCosts: 0,
      personnelSingleCosts: 0,
      listPrice: 10.95,
      materialCostsTextile: 1.80,
      maintenanceCosts: 0,
      printCostsWithTextiles: 0,
      combinedCost: 0,
      contributionMarginSingle: 0,
      contributionMarginSinglePercentage: 0,
      payoffQty: 0,
      payoffDuration: 0,
      totalsDataSet: [],
      pieDataSet: [],// For the pie chart
      turnover: 0,
      gtxPrinterPrice: devices_json[0].prices[0].price,
      pretreatmakerPrice: devices_json[1].prices[0].price,
      transferpressPrice: devices_json[2].prices[0].price,
      pretreatmakerLinePrice: devices_json[3].prices[0].price,
      dryerPrice: devices_json[4].prices[0].price,
      alertActive: false,
      showOverlay: false,
      width: 0,
      overrideAlert: false,// This is to avoid a never ending loop when the max scenario is selected but demand volume is higher than the max.
      showStepByStep: false,
    };
  }

  transformNaNorInfintyToZero = (value) =>{
    return isNaN(value) || !isFinite(value) ? 0.00 : value
  }

  toNumber = (value) => {
    return Number(this.transformNaNorInfintyToZero(value))
  }

  handleAlertScenarioChange(scenario){
    this.setState({alertActive: false})
    this.handleScenarioChange(scenario)
  }

  updateTotals(){
    // Handle all totals update across the state.
    // Calculate costs
    //// Personnel Costs
    const personnelSingleCosts = this.toNumber(this.state.personnelCosts / (this.state.demandVolume / 5 / this.state.productionHours));
    this.setState({
      personnelSingleCosts: personnelSingleCosts
    })

    const demandVolume = this.toNumber(this.state.demandVolume);

    // Check if demand volume hr fits our selected scenario
    const demandVolumeHr = this.toNumber(demandVolume / 5 / this.state.productionHours);
    const scenarioDemandVolumeMax = Number(this.state.scenario.capacity)
    if(demandVolumeHr > scenarioDemandVolumeMax && !this.state.alertActive && !this.state.overrideAlert){
      // Try and work out the correct scenario
      var optimalScenario = scenarios_json.filter(scenario => scenario.capacity >= demandVolumeHr)[0];
      if(optimalScenario === undefined){
        optimalScenario = scenarios_json[5];// Grab the last scenario
      }

      // Check if alert override needs to be triggered to avoid an endless loop when demand volume is higher than highest scenario
      if(demandVolumeHr > optimalScenario.capacity){
        this.setState({
          overrideAlert: true
        })
      }
      // now show an alert if not open already
      this.setState({
        alertActive: true
      })

      if (window.confirm("Leider übersteigt Ihr Nachfragevolumen die Kapazität des Set ups. Möchten Sie die zum optimalen Set up wechseln?")) { 
        this.handleAlertScenarioChange(optimalScenario)
      }
      else{
        this.setState({alertActive: false})
      }
    }

    if(demandVolumeHr <= scenarioDemandVolumeMax && this.state.overrideAlert){
      this.setState({
        overrideAlert: false
      })
    }

    //// Maintenance Costs
    // Grab currency (only USD) and then add multiplier
    var multiplier = 1
    if (this.state.currency.id === 3){
      multiplier = 1.1922 // This is the EUR to USD conversion as per spreadsheet
    }

    var maintenanceCosts = Number(parseFloat(0.40 * multiplier).toFixed(2));

    this.setState({
      maintenanceCosts: this.toNumber(maintenanceCosts)
    })

    // Print color costs
    //// Grab white and cmyk costs
    //// Grab white and color textile costs
    const cmykPrice = this.toNumber(this.state.cmykPricing)
    const whitePrice = this.toNumber(this.state.whitePricing)

    const textileColorPercentage = this.toNumber((this.state.textileColorPercentage / 100));
    const printColorPercentage = this.toNumber((this.state.printColorPercentage / 100));
    //const qtyWhite = this.toNumber(0.2 * (1 + (0.3 * textileColorPercentage)));

    // Ink usage calculation
    //const inkWhiteWhitePercentage = this.toNumber((1 - textileColorPercentage) * (1.00 - printColorPercentage))
    const inkWhiteCmykPercentage = this.toNumber((1 - textileColorPercentage) * printColorPercentage)
    const inkColorWhitePercentage = this.toNumber(textileColorPercentage * (1.00 - printColorPercentage))
    const inkColorCmykPercentage = this.toNumber(textileColorPercentage * printColorPercentage)

    // wastage calculations
    const wastageWhiteWhite = 0
    const wastageWhiteCmyk = 0
    const wastageCmykWhite = inkWhiteCmykPercentage * 0.0018
    const wastageCmykCmyk = 0
    const wastageColorWhiteWhite = 0
    const wastageColorWhiteCmyk = inkColorWhitePercentage * 0.0063
    const wastageColorCmykWhite = inkColorCmykPercentage * 0.0018
    const wastageColorCmykCmyk = inkColorCmykPercentage * 0.0063

    // consumption calculations
    const consumptionCmyk = this.toNumber(wastageWhiteCmyk + wastageCmykCmyk + wastageColorWhiteCmyk + wastageColorCmykCmyk)
    const consumptionWhite = this.toNumber(wastageWhiteWhite + wastageCmykWhite + wastageColorWhiteWhite + wastageColorCmykWhite)
    const consumptionInkPriceCmyk = this.toNumber(cmykPrice * consumptionCmyk)
    const consumptionInkPriceWhite = this.toNumber(whitePrice * consumptionWhite)
    const consumptionInkPriceSum = this.toNumber(consumptionInkPriceCmyk + consumptionInkPriceWhite)

    // Pretreatment costs
    const pretreatmentPrice = this.toNumber(this.state.pretreatmentPrice)
    const pretreatmentGram = this.toNumber(pretreatmentPrice / 3)
    const dinQcm = this.toNumber(this.state.din.size_qcm)
    const pretreatmentPerItem = this.toNumber(dinQcm * 0.0300 * pretreatmentGram)

    // New calculation for pretreatment.
    const pretreamentPerItemWithColour = this.toNumber(pretreatmentPerItem * textileColorPercentage)

    const printCostsWithTextiles = this.toNumber((dinQcm * consumptionInkPriceSum) + pretreamentPerItemWithColour)
    this.setState({
      printCostsWithTextiles: printCostsWithTextiles
    })

    const textileCosts = this.toNumber(this.state.materialCostsTextile)
    const totalCosts = this.toNumber(printCostsWithTextiles + personnelSingleCosts + maintenanceCosts + textileCosts)
    this.setState({
      combinedCost: totalCosts
    }, this.props.triggerCombinedCostsUpdate(totalCosts))

    // Get totals for costs & investements
    // Stückdeckungsbeitrag
    const contributionMarginSingle = this.toNumber(this.state.listPrice - totalCosts)
    this.setState({
      contributionMarginSingle: contributionMarginSingle,
      contributionMarginSinglePercentage: this.toNumber((contributionMarginSingle / this.state.listPrice) * 100)
    })

    const turnOver = this.toNumber(this.state.listPrice * this.state.demandVolume * this.state.productionWeeks)
    const variableCosts = this.toNumber(totalCosts * this.state.demandVolume * 4 * 12)
    const investment = this.toNumber(this.state.deviceInvestment)
    // Deckungsbeitrag 2
    const contributionMargin = this.toNumber(turnOver - variableCosts - investment)
    // Amortisations
    const payoffQty = this.toNumber(investment / contributionMarginSingle)
    const payoffDuration = this.toNumber(payoffQty / this.state.demandVolume / (this.state.productionWeeks / 12))

    // Set up pie chart data set
    const pieData = [
      {
        title: Lang.translate(`calculator:variableCosts`, this.props.location.pathname),
        amount: variableCosts,
        amountPercentage: this.toNumber(variableCosts / turnOver)
      },
      {
        title: Lang.translate(`calculator:investment`, this.props.location.pathname),
        amount: investment,
        amountPercentage: this.toNumber(investment / turnOver)
      },
      {
        title: Lang.translate(`calculator:contributionMargin`, this.props.location.pathname),
        amount: contributionMargin,
        amountPercentage: this.toNumber(contributionMargin / turnOver)
      },
    ]

    this.setState({
      payoffQty: payoffQty,
      payoffDuration: payoffDuration,
      turnover: turnOver,
      pieDataSet: pieData
    })

    // Now we want to set up 24 months worth of data,
    // which we'll use for the totals and graph chart

    const backflow = this.toNumber((this.state.productionWeeks / 12) * demandVolume * contributionMarginSingle)
    const investmentNegative = this.toNumber(investment * -1)

    var totalsData = []
    const monthsToCalculate = 24
    var investmentNegativeStep = investmentNegative;

    for (let index = 0; index < monthsToCalculate; index++) {
      var restSum = (backflow + investmentNegativeStep)
      investmentNegativeStep = restSum
      totalsData.push({
        month: (index + 1),
        sum: this.toNumber(parseFloat(restSum).toFixed(2))
      })
    }

    this.setState({
      totalsDataSet: totalsData
    })

    this.props.updatePricing(this.state.devicePricing)
    this.props.triggerCombinedCostsUpdate(totalCosts)
  }

  calculateDevicePricing(){
    const recommendedDevices = this.state.recommendedDevices
    const allDevices = this.state.allDevices

    if(recommendedDevices !== null && recommendedDevices.length > 0 && allDevices !== null && allDevices.length > 0){
      var devicePricingData = []
      var overallSum = 0
      const self = this
      recommendedDevices.forEach(function(entry) {
        const deviceData = allDevices.filter(devices => devices.id === entry.id)[0];
        const pricing = deviceData.prices.filter(price => price.id === self.state.currency.id)[0];
        var price = 0.00
        if(entry.id === 1){
          price = pricing.price
        }
        else if(entry.id === 2){
          price = pricing.price
        }
        else if(entry.id === 3){
          price = pricing.price
        }
        else if(entry.id === 4){
          price = pricing.price
        }
        else if(entry.id === 5){
          price = pricing.price
        }
        const sum = price * entry.qty
        overallSum += sum
        devicePricingData.push({
          id: entry.id,
          name: deviceData.name,
          localeName: deviceData.localeName,
          qty: entry.qty,
          unit_price: self.toNumber(price),
          price_sum: sum
        })
      })

      this.setState({
        devicePricing: devicePricingData,
        deviceInvestment: overallSum
      }, () => {
        this.updateTotals()
      })
    }
  }

  calculateInkPricing(){
    const ink = this.state.ink;
    if(ink){
      const inkColorPricing = [];
      for (let index = 0; index < ink.colors.length; index++) {
        const color = ink.colors[index];
        const pricing = color.prices.filter(price => price.id === this.state.currency.id)[0];
        inkColorPricing.push({
          id: color.id,
          name: color.name,
          price: pricing.price,
          price_ml: pricing.price / ink.size
        })
        this.setState({
          [color.name + "Pricing"]: pricing.price / ink.size
        })
      }

      if(inkColorPricing.length > 0){
        this.setState({
          inkPricing: inkColorPricing
        }, this.updateTotals)
      }
    }

  }

  calculatePretreatmentPricing(){
    const pretreatment = this.state.pretreatment;
    if(pretreatment){
      const pretreatmentPricing = [];
      // There should only be one slected, so no need for a loop.
      const pricing = pretreatment.prices.filter(price => price.id === this.state.currency.id)[0];
      pretreatmentPricing.push({
        id: pretreatment.id,
        name: pretreatment.name,
        price: pricing.price,
        price_g: pricing.price / (pretreatment.size*1000)
      })

      this.setState({
        pretreatmentPrice: pricing.price / (pretreatment.size*1000)
      })

      if(pretreatmentPricing.length > 0){
        this.setState({
          pretreatmentPricing: pretreatmentPricing
        }, this.updateTotals)
      }
    }
  }

  handlePricingDataChange(){
    this.calculateDevicePricing()
    this.calculateInkPricing()
    this.calculatePretreatmentPricing()
    this.updateTotals()
  }

  handleDeviceUserInputChange(value, name){
    this.setState({
      [name]:Number(value)
    }, this.calculateDevicePricing)
  }

  handleCurrencyChange(selected){
    this.setState({
      currency: selected
    }, this.handlePricingDataChange)
    this.props.triggerCurrencyChange(selected)
  }

  handleDinChange(selected){
    this.setState({
      din: selected
    }, this.updateTotals)
  }

  handlePretreatmentChange(selected){
    this.setState({
      pretreatment: selected
    },this.handlePricingDataChange)
  }

  handleInkQtyChange(selected){
    this.setState({
      ink: selected
    }, this.handlePricingDataChange)
  }

  handlePrintColorPercentageChange(selected){
    this.setState({
      printColorPercentage: selected
    }, this.handlePricingDataChange)
  }

  handleTextileColorPercentageChange(selected){
    const selectedNumber = Number(selected)
    var hasPretreatmaker = true
    if(selectedNumber === 0){
      hasPretreatmaker = false
    }
    this.setState({
      textileColorPercentage: selected,
      hasPretreatmaker: hasPretreatmaker
    }, this.handlePricingDataChange)
  }

  handleUserInputChange(value, name){
    // Grab state name by... name
    this.setState({
      [name]:Number(value)
    }, this.updateTotals)
  }

  handleScenarioChange(selected){
    this.setState({
      scenario: selected
    })
    // Now we need to grab what devices we need.
    if(selected !== null){
      var suggestedDevices = []
      var scenarioItems = selected.items;
      for (var i = 0; i < scenarioItems.length; i++){
        suggestedDevices.push({
          id: scenarioItems[i].id,
          qty: scenarioItems[i].qty
        })
      }

      if(suggestedDevices.length > 0){
        this.setState({
          recommendedDevices: suggestedDevices
        }, this.handlePricingDataChange)
      }

      // If we have a scenario above "M" we need to change the Tintenpackung and Pretreatmentpackung
      if(selected.capacity !== null && selected.capacity >= 105){
        // for both JSON data points we only have 2 entries. Here, for speed, I am selected the last item in the feed.
        this.handlePretreatmentChange(pretreatment_json[1])
        this.handleInkQtyChange(ink_json[1])
      }
    }
    
  }

  componentDidUpdate() {
    if (typeof this.props.triggerScenarioChange !== 'undefined' && this.props.triggerScenarioChange && this.props.triggerScenarioChange !== this.state.scenario) {
      this.handleScenarioChange(this.props.triggerScenarioChange)
      this.props.clearTrigger()
    }

    //hasTouchedBase
    if (!this.hasTouchedBase && this.state.devicePricing.length > 0) {
      this.hasTouchedBase = true
      this.props.updatePricing(this.state.devicePricing)
    }
  }

  showOverlay(ev, shouldShow) {
    if(ev !== null){
      ev.preventDefault()
    }
    if (shouldShow) {
      this.setState({
        showOverlay: true
      })
    } else {
      this.setState({
        showOverlay: false
      })
    }
  }

  handleReset(){
    const root = document.getElementById('root');
    root.scrollIntoView({behavior: "instant", block: "start"});
    window.location.reload()
  }

  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  toggleStepByStep = () => {
    this.setState({
      showStepByStep: this.state.showStepByStep ? false : true
    })
  }

  render() {

    const currency = this.state.currency;
    const scenario = this.state.scenario;
    const devicePricing = this.state.devicePricing;
    const din = this.state.din;
    const pretreatment = this.state.pretreatment;
    const ink = this.state.ink;
    const inkPricing = this.state.inkPricing;
    const totalsDataSet = this.state.totalsDataSet;
    const pathName = this.props.location.pathname

    return (
      <div className={classNames(styles.inputWrapperContainer, 'calculator')}>

        <div className={styles.inputWrapperContainerInner}>
          <div className={styles.titleContainer}>
            <div className={styles.titleInner}>
              <h2>{Lang.translate('calculator:title', pathName)}</h2>
              <p>{Lang.translate('calculator:introText', pathName)}</p>
            </div>
          </div>
        </div>

        <ScenarioOverview
          scenarioData={scenario}
          deviceData={devicePricing}
          currency={currency}
          showOverlay={ (ev, shouldShow) => this.showOverlay(ev, shouldShow) }
        />

        <div className={styles.inputWrapperContainerInner}>

          <Overlay
            changeDevicePrice={ (device) => { this.triggerDevicePriceChange(device) } }
            triggerScenarioChange={(scenario) => this.handleScenarioChange(scenario)}
            shouldShow={ this.state.showOverlay }
            showOverlay={ (ev, shouldShow) => this.showOverlay(ev, shouldShow) }
            scenarioData={scenario}
            deviceData={devicePricing}
            currency={currency}
            //onChange={this.handleDeviceUserInputChange}
          />
          
          <Room currentScenario={ this.state.scenario } />

          <Help styles={styles} />
          <div className={styles.stepbystepbutton}>
            
            <button className={styles.btn} onClick={() => this.toggleStepByStep()}>{Lang.translate('steps:title', pathName)}</button>
          </div>

          <section className={styles.inputWrapper}>
        
            <section className={styles.inputColumn}>
              <div className={styles.inputContainer}>
                <CurrencyDropdown
                  data={currencies_json}
                  onChange={this.handleCurrencyChange}
                  unitInfo={Lang.translate('calculator:unit', pathName)}
                  description={Lang.translate('calculator:currency', pathName)}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier wählen Sie die Währung aus."
                />
                <ScenarioDropdown
                  data={scenarios_json}
                  onChange={this.handleScenarioChange}
                  name="scenario"
                  selected={scenario}
                  returnShortName="true"
                  styles={styles}
                  icon={infoIcon}
                  unitInfo={Lang.translate('calculator:unit', pathName)}
                  description="GTX-Setup"
                  helpText="Hier wählen Sie die Einheit aus."
                />
                <ReadOnlyInput
                  value={scenario.capacity}
                  unitInfo={Lang.translate('calculator:pieceHour', pathName)}
                  description={Lang.translate('calculator:capacity', pathName)}
                  styles={styles}
                  icon={infoIcon}
                  floatValue='false'
                  helpText="Hier erfahren Sie die Anzahl der Stücke pro Stunde."
                />
                <OverviewGroup
                  styles={styles}
                  icon={infoIcon}
                  currency={currency}
                  deviceData={devicePricing}
                  inkData={inkPricing}
                  ink={ink}
                />

                {this.state.width > 685 ?
                  <PieChart
                    data={this.state.pieDataSet}
                    currency={currency}
                    icon={infoIcon}
                    styles={styles}
                  />
                  : null
                }
                

              </div>

            </section>

            <section className={styles.inputColumn}>
              <div className={styles.inputContainer}>

                <UserInput
                  description={Lang.translate('calculator:demandVolume', pathName)}
                  unitInfo={Lang.translate('calculator:pieceWeek', pathName)}
                  name="demandVolume"
                  onChange={this.handleUserInputChange}
                  value={this.state.demandVolume}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Anzahl der Stücke pro Woche."
                />
                <UserInput
                  description={Lang.translate('calculator:materialCostsTextile', pathName)}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  name="materialCostsTextile"
                  onChange={this.handleUserInputChange}
                  value={this.state.materialCostsTextile}
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Materialkosten (Textil) pro Stück."
                />

                <UserInput
                  description={Lang.translate('calculator:productionWeeks', pathName)}
                  unitInfo={Lang.translate('calculator:weekYear', pathName)}
                  onChange={this.handleUserInputChange}
                  value={this.state.productionWeeks}
                  name="productionWeeks"
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Anzahl der Produktionswoche pro Jahr."
                />
                <ReadOnlyInput
                  value={this.state.printCostsWithTextiles}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  description={Lang.translate('calculator:printCosts', pathName)}
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Druckkosten pro Stück."
                />

                <UserInput
                  description={Lang.translate('calculator:productionHours', pathName)}
                  unitInfo={Lang.translate('calculator:hoursDay', pathName)}
                  onChange={this.handleUserInputChange}
                  value={this.state.productionHours}
                  name="productionHours"
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Anzahl der Produktionsstunden pro Tag."
                />
                <ReadOnlyInput
                  value={this.state.maintenanceCosts}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  description={Lang.translate('calculator:maintenanceCosts', pathName)}
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Wartungskosten pro Stück."
                />

                {/*<UserInput
                  description="Personalkosten"
                  unitInfo="h"
                  onChange={this.handleUserInputChange}
                  value='10'
                  name="personnelCosts"
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Personalkosten pro Stunde."
                />
                <ReadOnlyInput
                  value={this.state.personnelSingleCosts}
                  unitInfo="Stück"
                  description="Personalkosten"
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Personalkosten pro Stück."
                />*/}

                <UserInput
                  description={Lang.translate('calculator:listPrice', pathName)}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  onChange={this.handleUserInputChange}
                  value={this.state.listPrice}
                  name="listPrice"
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie den Listenpreis pro Stück."
                />
                <ReadOnlyInput
                  value={this.state.combinedCost}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  description={Lang.translate('calculator:costPerPiece', pathName)}
                  currency={currency}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Kosten pro Stück."
                />

                {this.state.width > 685 ?
                  <BarChart
                    data={totalsDataSet}
                    icon={infoIcon}
                    styles={styles}
                  />
                  : null
                }

              </div>

            </section>

            <section className={styles.inputColumn}>
              <div className={styles.inputContainer}>
                <SliderGroup
                  styles={styles}
                  onChangeColor={this.handlePrintColorPercentageChange}
                  onChangeTextile={this.handleTextileColorPercentageChange}
                  printColorPercentage={this.state.printColorPercentage}
                  textileColorPercentage={this.state.textileColorPercentage}
                />
                <DropdownGroup
                  styles={styles}
                  pretreatmentData={pretreatment_json}
                  onChangePretreatment={this.handlePretreatmentChange}
                  pretreatment={pretreatment}
                  dinData={din_json}
                  onChangeDin={this.handleDinChange}
                  din={din}
                  inkData={ink_json}
                  onChangeInk={this.handleInkQtyChange}
                  ink={ink}
                />
                <ReadOnlyInput
                  value={this.state.payoffDuration}
                  unitInfo={Lang.translate('calculator:months', pathName)}
                  description={Lang.translate('calculator:amortisationPeriod', pathName)}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Amortisationsdauer in Monaten."
                  highlightBox={true}
                />
                <ReadOnlyInput
                  value={this.state.payoffQty}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  description={Lang.translate('calculator:amortisationAmount', pathName)}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie die Amortisationsmenge in Stücken."
                  highlightBox={true}
                />
                <ReadOnlyInput
                  value={this.state.contributionMarginSingle}
                  unitInfo={Lang.translate('calculator:piece', pathName)}
                  description={Lang.translate('calculator:contributionMargin', pathName)}
                  styles={styles}
                  icon={infoIcon}
                  currency={currency}
                  helpText="Hier erfahren Sie den Deckungsbeitrag pro Stück."
                  highlightBox={true}
                />
                <ReadOnlyInput
                  value={this.state.contributionMarginSinglePercentage}
                  unitInfo="%"
                  description={Lang.translate('calculator:contributionMargin', pathName)}
                  styles={styles}
                  icon={infoIcon}
                  helpText="Hier erfahren Sie den Deckungsbeitrag in Prozent."
                  highlightBox={true}
                />

                <Totals
                  data={this.state.totalsDataSet}
                  styles={styles}
                  icon={infoIcon}
                  helpText=""
                  highlightBox={true}
                />

                {this.state.width <= 685 ?
                  <BarChart
                    data={totalsDataSet}
                    icon={infoIcon}
                    styles={styles}
                  />
                  : null
                }

                {this.state.width <= 685 ?
                  <PieChart
                    data={this.state.pieDataSet}
                    currency={currency}
                    icon={infoIcon}
                    styles={styles}
                  />
                  : null
                }

              </div>
            </section>

         </section>
          <div className={styles.footnote}>
            <p>{Lang.translate('calculator:termsLine1', pathName)}</p>
            <p>{Lang.translate('calculator:termsLine2', pathName)}</p>
          </div>
        </div>
        <Steps
          isOpen={this.state.showStepByStep}
          toggleStepByStep={() => this.toggleStepByStep()}
          handleUserInputChange={(value, name) => this.handleUserInputChange(value, name)}
          calculatorState={this.state}
          onChangeColor={this.handlePrintColorPercentageChange}
          onChangeTextile={this.handleTextileColorPercentageChange}
        />
      </div>
    );
  }
}

export default withRouter(Calculator);



// WEBPACK FOOTER //
// ./src/components/calculator/calculator.js